module.exports = __webpack_public_path__ + "static/media/NP_logo_A_bloody.540d3fe5.png";